import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import FeedUsageComponent from '@app/components/apps/FeedMaterialUsage/FeedMaterialUsage';

export const EditFeedUsage: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Edit Feed Usage');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    { path: '/feed-material-usage', breadcrumbName: 'Feed Material Usage' },
    { path: `/edit-feed-usage/${id}`, breadcrumbName: 'Edit Feed Usage' },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <FeedUsageComponent
          type={'edit'}
          editable={true}
          id={id}
          pageTitle={`Edit Feed Usage`}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default EditFeedUsage;
